/* ==========================================================================
   cl-custom.js — Logique JavaScript Cave Larégnère
   --------------------------------------------------------------------------
   Ce fichier contient TOUTE notre logique front propre. Il s'appuie sur
   Alpine.js (déjà présent dans le thème) sans modifier les fichiers Eurus.

   Règle de maintenance :
   - Ne jamais patcher les gros scripts Eurus (variant-select.js,
     product-cart.js, cart-drawer.liquid…). On étend via des « stores »
     Alpine préfixés « cl » et via les événements déjà exposés par Eurus
     (ex. eurus:cart:redirect).
   - Ce script est chargé en defer AVANT vendors.js (Alpine), donc l'écouteur
     'alpine:init' ci-dessous est bien enregistré avant l'initialisation.
   ========================================================================== */

document.addEventListener('alpine:init', () => {
  // Les stores et composants Cave Larégnère seront déclarés ici.
  // Exemple à venir : Alpine.store('clAgeGate', { ... })
});

/* ============================================================================
   PRODUITS ÉPUISÉS EN FIN DE GRILLE
   ----------------------------------------------------------------------------
   Shopify ne sait pas trier une collection par disponibilité : ses tris sont
   alphabétique, prix, date, meilleures ventes ou manuel. L'ordre « en stock
   d'abord » doit donc être écrit dans la boutique par un traitement externe.

   Ce script est le filet posé DANS le thème : à chaque affichage d'une page,
   il fait descendre les fiches épuisées en bas de la grille. Il vit chez le
   visiteur, ne dépend d'aucun service, et continue de fonctionner même si plus
   personne n'intervient sur la boutique.

   Portée assumée : il réordonne la page AFFICHÉE. Sur un rayon paginé, un
   produit disponible de la page 2 ne remonte pas en page 1 — seul un
   reclassement écrit dans Shopify peut le faire. Sur les rayons d'une seule
   page, le résultat est exact.
   ========================================================================== */
(function () {
  var MARQUEURS = /épuisé|epuise|rupture|sold\s*out|indisponible/i;

  function visible(el) {
    /* Eurus laisse dans le DOM des mentions « Épuisé » masquées : sans ce
       contrôle, toutes les fiches étaient prises pour des ruptures. */
    if (!el) return false;
    if (el.offsetParent === null && getComputedStyle(el).position !== 'fixed') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function estEpuise(carte) {
    /* 1. un marqueur d'épuisement RÉELLEMENT affiché */
    var marque = carte.querySelector('[class*="sold-out"], [class*="soldout"], [class*="sold_out"]');
    if (visible(marque)) return true;
    /* 2. le bouton d'ajout désactivé */
    var bouton = carte.querySelector('button[disabled], .cl-atc[disabled], [class*="add"][disabled]');
    if (bouton) return true;
    /* 3. un badge visible portant la mention */
    var badges = carte.querySelectorAll('[class*="badge"], [class*="label"]');
    for (var i = 0; i < badges.length; i++) {
      if (visible(badges[i]) && MARQUEURS.test(badges[i].textContent || '')) return true;
    }
    return false;
  }

  function reordonner(grille) {
    var cartes = Array.prototype.slice.call(
      grille.querySelectorAll(':scope > card-product, :scope > .card-product, :scope > li, :scope > .grid__item')
    );
    if (cartes.length < 2) return;

    var epuises = cartes.filter(estEpuise);
    if (!epuises.length || epuises.length === cartes.length) return;

    /* déjà en ordre ? on ne touche à rien : évite de rejouer à chaque mutation */
    var premierEpuise = cartes.indexOf(epuises[0]);
    var dernierDispo = cartes.length - 1;
    while (dernierDispo >= 0 && epuises.indexOf(cartes[dernierDispo]) !== -1) dernierDispo--;
    if (premierEpuise > dernierDispo) return;

    var frag = document.createDocumentFragment();
    epuises.forEach(function (c) { frag.appendChild(c); });   /* déplace, ne clone pas */
    grille.appendChild(frag);
  }

  function balayer() {
    var vues = [];
    document.querySelectorAll('card-product, .card-product').forEach(function (c) {
      var parent = c.parentElement;
      if (parent && vues.indexOf(parent) === -1) vues.push(parent);
    });
    vues.forEach(reordonner);
  }

  function demarrer() {
    balayer();
    /* Les filtres et la pagination d'Eurus rechargent la grille sans recharger
       la page : on rebalaie après chaque remplacement de contenu, en différé
       pour laisser le thème finir son rendu. */
    /* ⚠️ Surveillance restreinte aux CONTENEURS DE GRILLE, jamais au body :
       observer tout le document faisait réagir ce script à chaque rendu
       d'Alpine (fenêtre d'âge, panneaux latéraux, panier) et pouvait perturber
       ces composants. On n'écoute que là où les fiches produit changent. */
    var minuteur = null;
    var observateur = new MutationObserver(function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(balayer, 120);
    });
    var cibles = [];
    document.querySelectorAll('card-product, .card-product').forEach(function (c) {
      var g = c.parentElement;
      if (g && cibles.indexOf(g) === -1) { cibles.push(g); observateur.observe(g, { childList: true }); }
    });
    /* la grille elle-même peut être remplacée par les filtres : on surveille
       aussi son parent direct, sans descendre dans tout le document */
    cibles.forEach(function (g) {
      if (g.parentElement) observateur.observe(g.parentElement, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();

/* ============================================================================
   VÉRIFICATION D'ÂGE — RATTRAPAGE DU PREMIER CLIC
   ----------------------------------------------------------------------------
   La fenêtre est un composant Alpine du thème, le bouton « Oui » porte
   `@click.prevent="close()"`. Le balisage s'affiche avant qu'Alpine ne soit
   initialisé : un clic arrivé pendant cet intervalle n'est lié à rien et se
   perd — d'où l'obligation de cliquer deux fois.

   Première tentative : appeler `close()` via `Alpine.$data()`. Sans effet,
   Alpine n'étant pas exposé sur `window` dans ce thème.
   Approche retenue : reproduire exactement le geste du visiteur — si la
   fenêtre est encore là peu après, on rejoue UN clic sur le bouton. À cet
   instant Alpine est initialisé, le gestionnaire du thème répond, et c'est sa
   propre logique (cookie, mémorisation 30 jours) qui s'applique.
   Un verrou empêche toute répétition : une seule relance par bouton.
   ========================================================================== */
(function () {
  document.addEventListener('click', function (ev) {
    var bouton = ev.target.closest('button[class*="accept-button"], a[class*="accept-button"]');
    if (!bouton || bouton.dataset.clRelance === '1') return;

    var conteneur = bouton.closest('[x-data]') || document;

    setTimeout(function () {
      var modale = conteneur.querySelector ? conteneur.querySelector('[x-show]') : null;
      if (!modale || modale.offsetParent === null) return;   /* déjà fermée */
      bouton.dataset.clRelance = '1';                        /* une seule fois */
      bouton.click();
    }, 300);
  }, true);
})();
